import { createApp, markRaw } from 'vue'
import App from './App.vue'
import router from './router'
import '@mdi/font/css/materialdesignicons.css'
import { permission } from 'code-library/store/directives/permission';


// vue-axios
import axios from 'axios'
import VueAxios from 'vue-axios'

// axios.defaults.baseURL = `${process.env.VUE_APP_APIPATH}`;

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'


// pinia
import { createPinia } from "pinia";

const pinia = createPinia();

pinia.use(({ store }) => {
  store.$router = markRaw(router)
});

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
  },
})

const app = createApp(App).use(router).use(vuetify).use(pinia).use(VueAxios, { $myHttp: axios });
app.directive('permission', permission);

app.provide('$myHttp', app.config.globalProperties.$myHttp);
app.mount('#app')


router.beforeEach(async (to, from, next) => {
  if (to.meta.requiresAuth) {
    const accessToken = getCookieByName('accessToken') || null;

    if (!accessToken) {
      setCookieByName('path', window.location.href)
      window.location.href = `${process.env.VUE_APP_LOGIN}`;
      next(false);
      return;
    }

    // 檢查 AccessToken 是否過期，true 是沒過期
    const notExpired = await checkValidAccessToken(accessToken);

    // 沒過期，註銷帳號不可進入
    if (notExpired && to.meta.logOutlogOutStatusCannotEnter) {

      const mainUserInfo = await getUserInfoDetail(accessToken);

      const isLogOut = await checkUserAccountIsDeleted(mainUserInfo.email);

      if (isLogOut) {
        // 註銷帳號，不可進入
        window.location.href = `${process.env.VUE_APP_LOGIN}`;
        next(false);
      } else {
        next();
      }

      return;
    }


    if (notExpired) {
      // 沒過期
      next();
    } else {
      // 過期
      setCookieByName('path', window.location.href);
      window.location.href = `${process.env.VUE_APP_LOGIN}`;
      next(false);
    }
  } else {
    next();
  }
});

// 檢查 AccessToken 是否過期，true 是沒過期
async function checkValidAccessToken(accessToken) {
  return await axios.get(`${process.env.VUE_APP_APIPATH_B}Token/CheckValidAccessToken?AccessToken=${accessToken}`).then((res) => {
    return res.data;
  }).catch((error) => {
    console.error(error, 'main checkAccessToken')
  })
}

// 檢查使用者帳號是否已註銷關閉，true 是已註銷帳號
async function checkUserAccountIsDeleted(userAccount) {
  return await axios.get(`${process.env.VUE_APP_APIPATH_B}BackendManagement/CheckUserAccountIsDeleted?UserAccount=${userAccount}`).then((res) => {
    return res.data;
  }).catch((error) => {
    console.error(error, 'main checkUserAccountIsDeleted')
  })
}

// 使用者基本資料查詢
async function getUserInfoDetail(accessToken) {
  return await axios.get(`${process.env.VUE_APP_APIPATH_B}UserInfo/GetUserInfoDetail`, {
    headers: {
      'Authorization': `Bearer ${accessToken}`
    }
  }).then((res) => {
    return res.data;
  }).catch((error) => {
    console.error(error, 'main getUserInfoDetail')
  })
}

function parseCookie() {
  let cookieObj = {};
  let cookieAry = document.cookie.split('; ');
  let cookie;

  for (let i = 0, l = cookieAry.length; i < l; ++i) {
    if (cookieAry[i].includes('=')) {
      cookie = cookieAry[i].split('=');
      cookieObj[cookie[0]] = cookie[1];
    }
  }
  return cookieObj;
}
function getCookieByName(name) {
  let value = parseCookie()[name];
  if (value)
    value = decodeURIComponent(value);
  return value;
}
// 設置 Cookie
function setCookieByName(key, value) {
  document.cookie = `${key}=${value};domain=${process.env.VUE_APP_COOKIE_DOMAIN};max-age=2592000;path=/;`;
}